import { VisuallyHidden } from '@reach/visually-hidden'
import { useState } from 'react'

import { CloseIcon } from '../icon'
import { Body, CloseButton, Container, Content, CtaLink, Headline, TextContent } from './sitewide-notice-banner.styles'

const DISMISSED_STORAGE_KEY = 'sitewideNoticeBannerDismissed'

interface SitewideNoticeBannerProps {
  // Only authenticated users may dismiss the banner; it always shows on the (unauthenticated) login page
  dismissible?: boolean
}

const SitewideNoticeBanner = ({ dismissible = false }: SitewideNoticeBannerProps) => {
  const [dismissed, setDismissed] = useState<boolean>(
    dismissible && localStorage.getItem(DISMISSED_STORAGE_KEY) === 'true'
  )

  if (dismissible && dismissed) return null

  const onDismiss = () => {
    localStorage.setItem(DISMISSED_STORAGE_KEY, 'true')
    setDismissed(true)
  }

  return (
    <Container>
      <Content>
        <TextContent>
          <Headline>🎉 Big upgrades ahead! Our brand new Protect website experience is live.</Headline>
          <Body>
            We built a modern website experience that’s easier to navigate, lets you see device statuses at a
            glance, and tells you what needs attention. The current site will fully transition to the new design in
            a few weeks. Switch today to explore the new design and update your bookmarks!
          </Body>
        </TextContent>
        <CtaLink href="https://app.meshifyprotect.com/" target="_blank" rel="noopener noreferrer">
          Explore the New Site
        </CtaLink>
      </Content>
      {dismissible && (
        <CloseButton onClick={onDismiss} aria-label="Dismiss">
          <CloseIcon fill="currentColor" />
          <VisuallyHidden>Dismiss</VisuallyHidden>
        </CloseButton>
      )}
    </Container>
  )
}

export default SitewideNoticeBanner
